import ButtonDanger from './ButtonDanger';

export default ButtonDanger;
